<template>
  <div class="chart-popover-content">
    <div class="chart-popover-content-inner">
      <div
        v-for="data in formattedData"
        :key="data.color"
        class="d-flex justify-content-between gap-15 values"
      >
        <div class="colors d-flex align-items-center gap-5">
          <div
            class="color-box"
            :style="{ background: `${data.color}` }"
          />
          <div class="name">{{ data.name }}</div>
        </div>

        <div class="time">{{ formatDuration(data.value) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { capitalize, find, keys, map, union } from 'lodash-es';
import { formatDuration } from '~/utils/time_utils';
import { REPORT_CHART_POPOVER_CONTENT_TITLES } from '~/app_constants';

export default {
  name: 'ReportChartPopoverContent',
  props: {
    dataValues: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedData() {
      return map(union(keys(this.dataValues.colors), map(this.dataValues.details, 'name')), (name) => {
        const valueObj = find(this.dataValues.details, ['name', name]) || { value: 0 };

        return {
          name: REPORT_CHART_POPOVER_CONTENT_TITLES[name] || capitalize(name),
          value: valueObj.value,
          color: this.dataValues.colors[name],
        };
      });
    },
  },
  methods: {
    formatDuration(duration) {
      return formatDuration(duration * 3600);
    },
  },
};
</script>
